export default "__VITE_ASSET__59336e50__"